import { Carousel } from '@fancyapps/ui/src/Carousel/Carousel.js'
import de from '@fancyapps/ui/src/Carousel/l10n/de'

const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  let galleries = document.querySelectorAll('.js-gallery')

  galleries.forEach(gallery => {
    let galleryId = gallery.getAttribute('id')

    // eslint-disable-next-line no-unused-vars
    const carousel = new Carousel(document.querySelector('#' + galleryId), {
      infinite: true,
      Dots: true,
      Navigation: {
        prevTpl:
          '<svg aria-hidden="true"><use href="/_assets/6fca067eff01c2af5c01a4355f0bcdd3/Images/IconSprite.svg#arrow-left"></use></svg>',
        nextTpl:
          '<svg aria-hidden="true"><use href="/_assets/6fca067eff01c2af5c01a4355f0bcdd3/Images/IconSprite.svg#arrow-right"></use></svg>'
      },
      slidesPerPage: 'auto',
      center: false,
      fill: false,
      l10n: de
    })
  })
})
